/**
 * Paddle 资源预加载组件
 * 在页面头部预加载 Paddle 相关资源
 */

import { useEffect } from 'react';
import { log } from '../utils/logger';

/**
 * Paddle 资源预加载组件
 */
export function PaddleResourcePreloader() {
  useEffect(() => {
    // 预加载 Paddle 相关的 DNS 和资源
    const preloadResources = () => {
      // DNS 预解析
      const dnsPreconnects = [
        'https://cdn.paddle.com',
        'https://checkout.paddle.com',
        'https://js.paddle.com',
        'https://pay.paddle.com',
      ];

      dnsPreconnects.forEach(url => {
        const link = document.createElement('link');
        link.rel = 'dns-prefetch';
        link.href = url;
        document.head.appendChild(link);
      });

      // 预连接到 Paddle 服务器
      const preconnects = [
        'https://cdn.paddle.com',
        'https://checkout.paddle.com',
      ];

      preconnects.forEach(url => {
        const link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = url;
        link.crossOrigin = 'anonymous';
        document.head.appendChild(link);
      });

      log.debug('Paddle 资源预加载完成');
    };

    // 延迟执行，避免阻塞页面渲染
    const timer = setTimeout(preloadResources, 100);
    
    return () => clearTimeout(timer);
  }, []);

  return null; // 不渲染任何内容
}

export default PaddleResourcePreloader;